import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, CssBaseline } from "@mui/material";
import "./fonts.css";
import { theme } from "./theme";

// `REACT_APP_MOCK=true npm start` renders the dashboard with fixture data (no
// Cognito, no backend). The NODE_ENV guard keeps the harness out of prod builds.
const RootApp =
  process.env.NODE_ENV === "development" && process.env.REACT_APP_MOCK === "true"
    ? React.lazy(() => import("./dev/MockApp"))
    : App;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  //<React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <React.Suspense fallback={null}>
      <RootApp />
    </React.Suspense>
  </ThemeProvider>
  //</React.StrictMode>
);
